module.exports = __webpack_public_path__ + "img/pen.57a41b18.svg";